var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "building-3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.96,
    height: 50,
    viewBox: "0 0 50.96 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_91183",
    "data-name": "Path 91183",
    d: "M51.19,23.288H2.269a1.019,1.019,0,1,1,0-2.038H51.19a1.019,1.019,0,1,1,0,2.038Z",
    transform: "translate(-1.25 26.687)",
    fill: "#09143a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91184",
    "data-name": "Path 91184",
    d: "M3.294,51.652a1.019,1.019,0,0,1-1.019-1.019L2.25,14.089A5.912,5.912,0,0,1,4.877,9.182l9.787-6.533a5.9,5.9,0,0,1,6.564,0L31.011,9.18a5.866,5.866,0,0,1,2.63,4.908l.024,36.494a1.019,1.019,0,0,1-1.017,1.02L3.3,51.652ZM17.946,3.691a3.837,3.837,0,0,0-2.147.652L6.012,10.876a3.875,3.875,0,0,0-1.724,3.213l.024,35.523,27.314-.046L31.6,14.089a3.835,3.835,0,0,0-1.72-3.211L20.095,4.345A3.839,3.839,0,0,0,17.946,3.691Z",
    transform: "translate(0.196 -1.652)",
    fill: "#09143a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91185",
    "data-name": "Path 91185",
    d: "M20.249,29.1a1.019,1.019,0,0,1-1.019-1.019V18.269a1.019,1.019,0,0,1,2.038,0v9.809A1.019,1.019,0,0,1,20.249,29.1Z",
    transform: "translate(24.75 20.903)",
    fill: "#09143a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91186",
    "data-name": "Path 91186",
    d: "M23.161,11.25a5.918,5.918,0,0,1,5.911,5.911v4.892a5.911,5.911,0,0,1-11.823,0V17.161A5.918,5.918,0,0,1,23.161,11.25Zm0,14.676a3.877,3.877,0,0,0,3.873-3.873V17.161a3.873,3.873,0,0,0-7.746,0v4.892A3.877,3.877,0,0,0,23.161,25.926Z",
    transform: "translate(21.887 12.226)",
    fill: "#09143a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91187",
    "data-name": "Path 91187",
    d: "M32.622,15.288H3.269a1.019,1.019,0,0,1,0-2.038H32.622a1.019,1.019,0,0,1,0,2.038Z",
    transform: "translate(0.196 15.119)",
    fill: "#09143a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91188",
    "data-name": "Path 91188",
    d: "M9.269,28.711A1.019,1.019,0,0,1,8.25,27.692V18.519a1.019,1.019,0,1,1,2.038,0v9.173A1.019,1.019,0,0,1,9.269,28.711Z",
    transform: "translate(8.872 21.264)",
    fill: "#09143a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_91189",
    "data-name": "Path 91189",
    d: "M11.438,16.127a4.688,4.688,0,1,1,4.688-4.688A4.694,4.694,0,0,1,11.438,16.127Zm0-7.338a2.65,2.65,0,1,0,2.65,2.65A2.653,2.653,0,0,0,11.438,8.788Z",
    transform: "translate(6.703 5.719)",
    fill: "#09143a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.7d923d3b07b6199854b945fd07037316.svg";
export { ForwardRef as ReactComponent };